import React from "react";
import { object } from "prop-types";

import { SectionHeading } from "../";

const SectionVideos = ({ style }) => (
  <div style={style}>
    <SectionHeading title="Training videos" icon="youtube" />
    <div style={{ padding: "0 8px" }}>
      <a
        href={"https://www.youtube.com/channel/UC3dXzoe4xiADgopR3vyUiGA"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        pdView's Youtube channel
      </a>
      <br />
      For free training please contact us - no obligations.
    </div>
  </div>
);

SectionVideos.propTypes = {
  style: object
};
export default SectionVideos;



// WEBPACK FOOTER //
// ./src/components/section_videos/SectionVideos.jsx